import { Model } from '@vuex-orm/core';


export default class User extends Model {
  static entity = 'users'

  static fields() {
    return {
      id: this.attr(null),
      email: this.attr(''),
      tag: this.string(false),
      toc: this.boolean(false),
      is_superuser: this.boolean(false),
      is_superadmin: this.boolean(false),
      created_at: this.string(null).nullable(),
    };
  }

  get role () {
    if (this.is_superadmin) {
      return 'superadmin';
    }
    if (this.is_superuser) {
      return 'admin';
    }
    return 'user';
  }
}
